const routes = [
  {
    path: 'company',
    name: 'company',
    meta: {
      requiredPrivileges:  ['System Settings']
    },
    component: () =>
      import('@/modules/global-settings/company/views/CompanyDetails.vue')
  },
  {
    path: 'branches',
    name: 'branches',
    meta: {
      requiredPrivileges:  ['System Settings']
    },
    component: () =>
      import('@/modules/global-settings/company/views/BranchPage.vue')
  },
  {
    path: 'departments',
    name: 'departments',
    meta: {
      requiredPrivileges:  ['System Settings']
    },
    component: () =>
      import('@/modules/global-settings/company/views/DepartmentPage.vue')
  },
  {
    path: 'currency-rate-settings',
    name: 'currency-rate-settings',
    meta: {
      requiredPrivileges:  ["System Settings"]
    },
    component: () =>
      import('@/modules/global-settings/company/views/CurrencyRateSettings.vue')
  }
];

export default routes;
